import moduleInfo from '../module.json';
import type { AppRuntime } from '@ayocore/platform/client/runtime/AppRuntime';
import { IconMessage } from '@tabler/icons-react';
import { lazy } from 'react';

/**
 * Бутстрап модуля Messaging (клиент)
 * Регистрирует демо-страницу для тестирования messaging.
 */
export async function setup(app: AppRuntime) {
  const messaging = app.useModule(moduleInfo.name, {
    version: moduleInfo.version,
    description: moduleInfo.description,
  });

  messaging.useNavigation([
    {
      icon: IconMessage,
      label: 'Messaging Demo',
      url: '/messaging/demo',
      component: lazy(() => import('./components/MessagingDemo')),
      hiddenFromMenu: true,
    },
  ]);
}
